var FORMAT_TYPE;
(function (FORMAT_TYPE) {
    FORMAT_TYPE[FORMAT_TYPE["CARD"] = 8] = "CARD";
    FORMAT_TYPE[FORMAT_TYPE["ATOM"] = 4] = "ATOM";
    FORMAT_TYPE[FORMAT_TYPE["INLINE"] = 2] = "INLINE";
    FORMAT_TYPE[FORMAT_TYPE["BLOCK"] = 1] = "BLOCK";
    FORMAT_TYPE[FORMAT_TYPE["INLINE_ATOM"] = 6] = "INLINE_ATOM";
    FORMAT_TYPE[FORMAT_TYPE["BLOCK_ATOM"] = 5] = "BLOCK_ATOM";
    FORMAT_TYPE[FORMAT_TYPE["INLINE_CARD"] = 10] = "INLINE_CARD";
    FORMAT_TYPE[FORMAT_TYPE["BLOCK_CARD"] = 9] = "BLOCK_CARD";
})(FORMAT_TYPE || (FORMAT_TYPE = {}));
// for remove useless tags to user
var SYL_TAG = '__syl_tag';
var SELECT_CLS = 'syl-selected-card';
var FLAG = Symbol.for('__schema_format_type__');
var META = Symbol.for('__schema_metadata__');
export { FLAG, FORMAT_TYPE, META, SELECT_CLS, SYL_TAG };
//# sourceMappingURL=const.js.map